import { DeleteConfirmDialog } from '../../../../components/common/DeleteConfirmDialog';
import { UnsavedChangesDialog } from '../../../../components/common/UnsavedChangesDialog';
import { ResetFiltersDialog } from '../../../../components/common/ResetFiltersConfirmDialog';

type GridDialogsProps = {
  // Delete Dialog
  deleteDialogOpen: boolean;
  onCloseDeleteDialog: () => void;
  onConfirmDelete: () => Promise<void>;
  isDeleting?: boolean;
  deleteTitle?: string;
  deleteMessage?: string;

  // Unsaved Changes Dialog
  unsavedDialogOpen: boolean;
  onCloseUnsaved: () => void;
  onDiscardChanges: () => void;
  onSaveChanges: () => Promise<void>;
  savingChanges?: boolean;
  saveError?: string | null;

  // Reset Filters Dialog
  resetFiltersDialogOpen: boolean;
  onCloseResetFiltersDialog: () => void;
  onConfirmResetFilters: () => void;
};

export const GridDialogs = ({
  deleteDialogOpen,
  onCloseDeleteDialog,
  onConfirmDelete,
  isDeleting,
  deleteTitle,
  deleteMessage,
  unsavedDialogOpen,
  onCloseUnsaved,
  onDiscardChanges,
  onSaveChanges,
  savingChanges,
  saveError,
  resetFiltersDialogOpen,
  onCloseResetFiltersDialog,
  onConfirmResetFilters,
}: GridDialogsProps) => {
  return (
    <>
      <DeleteConfirmDialog
        open={deleteDialogOpen}
        onClose={onCloseDeleteDialog}
        onConfirm={onConfirmDelete}
        loading={isDeleting}
        title={deleteTitle}
        message={deleteMessage}
      />

      <UnsavedChangesDialog
        open={unsavedDialogOpen}
        onClose={onCloseUnsaved}
        onDiscard={onDiscardChanges}
        onSave={onSaveChanges}
        saving={savingChanges}
        error={saveError}
      />

      <ResetFiltersDialog
        open={resetFiltersDialogOpen}
        onClose={onCloseResetFiltersDialog}
        onConfirm={onConfirmResetFilters}
      />
    </>
  );
};
